
import ContactUs from './pages/ContactUs';
import Home from './pages/Home';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Loan from './pages/Loan';
import RealEstate from './pages/RealEstate';
import AboutUs from './pages/AboutUs';
import MutualFund from './pages/MutualFund';
import Header from './pages/Header';
import Insurance from './pages/Insurance';
import AllEnquiryReport from './reports/allenquiry';

function App() {
  const location = useLocation();

  useEffect(() => {
    let tries = 0;
    let timer;
    const run = () => {
      const owlReady = typeof window.hjInitOwl === 'function';
      const themeReady = typeof window.hjInitTheme === 'function';
      if (owlReady) {
        window.hjInitOwl();
      }
      if (themeReady) {
        window.hjInitTheme();
      }
      if ((!owlReady || !themeReady) && tries < 20) {
        tries += 1;
        timer = window.setTimeout(run, 50);
      }
    };
    run();
    return () => window.clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <Header />
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/aboutus' element={<AboutUs/>}/>
        <Route path='/contactus' element={<ContactUs/>}/>
        <Route path='/insurance' element={<Insurance/>}/>
        <Route path='/loan' element={<Loan/>}/>
        <Route path='/mutualfund' element={<MutualFund/>}/>
        <Route path='/realestate' element={<RealEstate/>}/>
        <Route path='/all-enquiry' element={<AllEnquiryReport/>}/>
        <Route path='/allenquiry' element={<Navigate to="/all-enquiry" replace />}/>
      </Routes>
    </>
  );
}

export default App;
